export default __webpack_public_path__ + "static/media/hamburguer-contac.d3eef29f.jpg";